<template>
  <!-- TODO: remove the style attribute -->
  <div
    class="w-8 h-8 rounded-md flex justify-center items-center"
    :class="{
      'bg-white bg-opacity-90 border-surface-300 border': !isActive,
      'bg-primary-500 border-primary-600 border': isActive,
    }"
    style="
      box-shadow: var(
        --this-one-box-shadow,
        0px 1px 2px 0px rgba(16, 24, 40, 0.05)
      );
    "
  >
    <font-awesome-icon
      v-if="icon"
      :icon="icon"
      :class="{
        'text-surface-600 text-base': !isActive,
        'text-white': isActive,
      }"
      fixed-width
    />
  </div>
</template>

<script setup lang="ts">
defineProps({
  icon: {
    type: String as PropType<string | undefined>,
    required: false,
    default: undefined,
  },
  isActive: {
    type: Boolean,
    required: false,
    default: false,
  },
})
</script>
